import * as auth from 'Auth';
import * as api from 'api/Console';
import * as paths from 'Paths';
import consoleStore from 'stores/Console/ConsoleStore';
import constants from 'Constants';


export function handleSwitchAccount(evt, account, history) {
  if (!account.id) return;

  // update account ID so that we're fetching new account data
  auth.setAccountId(account.id);

  // switch after consoleStore is updated
  const successCallback = (response) => {
    consoleStore.deserialize(response);

    const link = paths.getPathHome();
    if (!link) return;

    evt.preventDefault();
    history.push(link);
  }

  const errorCallback = (errors) => {};
  api.getConsoleContext(successCallback, errorCallback);
}


export function handleSwitchProduct(evt, product, history) {
  if (!product) return;
  auth.setCurrentProduct(product);

  const link = paths.getProductHome(product);
  if (!link) return;

  evt.preventDefault();
  history.push(link);
}
